import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import reviewService from "../../services/ReviewService";

const ReviewNoteModal = (props) => {
  const { show, onHide, data, noteDetail, setNoteDetail } = props;

  const [showInput, setShowInput] = useState(true);
  const [note, setNote] = useState(null);

  useEffect(() => {
    let updateList = noteDetail.map(item => {
      if(item.id === data?.clipId)
      {
        return{...item, key: data?.notes}
      }
      return item;
    })
    setNoteDetail(updateList);
  }, []);
  
  const handleChange = async(e) => {
    setNote(e.target.value);
  };

  const handleConfirm = async () => {
    let updateList = noteDetail.map(item => {
      if(item.id === data?.clipId)
      {
        return{...item, key: note}
      }
      return item;
    })
    setNoteDetail(updateList);
    setNote(null);
    await reviewService.setClipNoteReviewed(data.clipId, note);
  };

  const handleDelete = async () => {
    let updateList = noteDetail.map(item => {
      if(item.id === data?.clipId)
      {
        return{...item, key: note}
      }
      return item;
    })
    setNoteDetail(updateList);
    await reviewService.setClipNoteReviewed(data.clipId, "");
    setNote(null);
  };

  let showInputArea =
    showInput && data ? (
      <div
        style={{
          height: 90,
          backgroundColor: "#D6D6D6",
          borderRadius: 2,
          padding: 10,
        }}
      >
        {note ? note : noteDetail?.filter(y=> y.id === data?.clipId)[0]?.key}
      </div>
    ) : (
      <Form>
        <Form.Group className="mb-3">
          <Form.Control
            as="textarea"
            rows={3}
            value={note ? note : noteDetail?.filter(y=> y.id === data?.clipId)[0]?.key}
            onChange={handleChange}
          />
        </Form.Group>
      </Form>
    );

  return (
    <Modal
      show={show}
      onHide={() => {
        setShowInput(true);
        onHide();
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Note</Modal.Title>
      </Modal.Header>
      <Modal.Body>{showInputArea}</Modal.Body>
      <Modal.Footer>
        {showInput ? (
          <>
            <Button
              variant="success"
              onClick={() => {
                setShowInput(true);
                handleConfirm()
                onHide();
              }}
            >
              <i className="fa-solid fa-check"></i>
            </Button>
            <Button variant="primary" onClick={() => setShowInput(false)}>
                <i className="fa-sharp fa-solid fa-pen-to-square"></i>
            </Button>
            {Array.from(noteDetail)?.filter(y=> y.id === data?.clipId)[0]?.key && (
              <Button
              variant="danger"
              onClick={() => {
                handleDelete();
                onHide();
              }}
            >
              <i className="fa-regular fa-trash-can"></i>
            </Button>
            )}
            </>
        ) : (
          <>
            <Button
              variant="success"
              onClick={() => {
                setShowInput(true);
              }}
            >
              <i className="fa-regular fa-check"></i>
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ReviewNoteModal;
